export default __webpack_public_path__ + "static/media/englishIcon.501671a5.svg";